module.exports = __webpack_public_path__ + "img/37-dec.da867083.png";